var App = App || {};

App.Header = (function ($) {
    'use strict';

    function MegaMenu() {

        let mmActive = false;
        const mmSpeed = 200;
        const mmTimer = 300;

        let mmOpenTimer;
        let mmCloseTimer;
        let mmTabOpenTimer;

        const mmContainer = $("header .header-primary > nav > ul");
        const mmTrigger = mmContainer.children("li").children("button");
        const mmItems = mmContainer.find(".mega-menu").find("a, button");
        const mmLevel2Tabs = mmContainer.find(".mega-menu .nav-link");
        const mmLevel3Items = mmContainer.find(".mega-menu .tab-pane a");
        const mmQuickLinks = mmContainer.find(".mega-menu-quicklinks a");

        let mmActiveItems = [];
        let mmActiveItem = 0;

        mmItems.attr("tabindex", -1);

        // Activate tab manually
        function activateTab($tab) {
            const targetId = $tab.attr("data-bs-target");
            const $tabPane = $(targetId);
            const $megaMenu = $tab.closest(".mega-menu");
            
            // Deactivate all tabs and hide all panes
            $tab.closest(".nav").find(".nav-link").removeClass("active").attr("aria-selected", "false");
            $megaMenu.find(".tab-pane").removeClass("show active");
            
            // Activate selected tab and show pane with fade in
            $tab.addClass("active").attr("aria-selected", "true");
            $tabPane.addClass("active");
            $tabPane[0].offsetHeight; // Force reflow
            setTimeout(() => $tabPane.addClass("show"), 10);
        }

        // Get all focusable items in the mega menu
        function getAllFocusableItems($megaMenu) {
            const items = [];
            
            $megaMenu.find(".nav-link").each(function() { items.push(this); });
            $megaMenu.find(".tab-pane.active.show a:visible").each(function() { items.push(this); });
            $megaMenu.find(".mega-menu-quicklinks a").each(function() { items.push(this); });
            
            return items;
        }

        // Navigate to next/previous item in list with wrapping
        function navigateItems($megaMenu, currentElement, direction) {
            mmActive = true;
            mmActiveItems = getAllFocusableItems($megaMenu);
            mmActiveItem = mmActiveItems.indexOf(currentElement);
            
            if (direction === "next") {
                mmActiveItem = mmActiveItem < mmActiveItems.length - 1 ? mmActiveItem + 1 : 0;
            } else if (direction === "prev") {
                mmActiveItem = mmActiveItem > 0 ? mmActiveItem - 1 : mmActiveItems.length - 1;
            } else if (direction === "first") {
                mmActiveItem = 0;
            } else if (direction === "last") {
                mmActiveItem = mmActiveItems.length - 1;
            }
            
            if (mmActiveItems.length > 0 && mmActiveItems[mmActiveItem]) {
                $(mmActiveItems[mmActiveItem]).trigger("focus");
            }
        }

        // Common keyboard handler for navigation keys
        function handleNavigationKeys(e, $megaMenu, element, options = {}) {
            const keyMap = {
                "ArrowDown": () => navigateItems($megaMenu, element, "next"),
                "ArrowUp": () => navigateItems($megaMenu, element, "prev"),
                "Home": () => navigateItems($megaMenu, element, "first"),
                "End": () => navigateItems($megaMenu, element, "last"),
                "Escape": () => {
                    const MenuButton = $(element).parents(".mega-menu").siblings("a, button");
                    MegaMenuClose(MenuButton, mmSpeed);
                }
            };

            // Add custom handlers if provided
            if (options.customHandlers) {
                Object.assign(keyMap, options.customHandlers);
            }

            const handler = keyMap[e.key];
            if (handler) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                handler();
            }
        }

        // Handle manual tab activation on click and mouseenter with delay
        mmLevel2Tabs.on("click mouseenter", function (e) {
            const $this = $(this);
            
            window.clearTimeout(mmTabOpenTimer);
            
            if (e.type === "click") {
                e.preventDefault();
                activateTab($this);
            } else {
                mmTabOpenTimer = window.setTimeout(() => activateTab($this), mmTimer);
            }
        }).on("mouseleave", function () {
            window.clearTimeout(mmTabOpenTimer);
        });

        mmContainer.on("mouseleave", function () {
            mmActive = false;
            mmTrigger.trigger("blur");
            mmCloseTimer = window.setTimeout(() => MegaMenuClose(mmTrigger, mmSpeed), mmTimer);
        }).on("keydown", function (e) {
            if (e.key === "Tab") {
                const isFromTriggerButton = $(e.target).is(mmTrigger);

                if (isFromTriggerButton) {
                    // Check if we're tabbing off the first or last trigger button
                    const $currentTrigger = $(e.target);
                    const $parentLi = $currentTrigger.parent("li");
                    const isFirstButton = $parentLi.is(":first-child");
                    const isLastButton = $parentLi.is(":last-child");
                    const isShiftTab = e.shiftKey;

                    // Close menu if shift-tabbing from first button or tabbing from last button
                    if ((isShiftTab && isFirstButton) || (!isShiftTab && isLastButton)) {
                        mmActive = false;
                        MegaMenuClose(mmTrigger, 1);
                    }
                } else {
                    // Always close if Tab is from within mega menu content
                    mmActive = false;
                    MegaMenuClose($(this).children("li").children("a, button"), 1);
                }
            }
        });

        mmTrigger.on("click focus mouseenter", function (e) {
            var $this = $(this);
            var mmTimerFocus = (e.type === "click" || e.type === "focus") ? 1 : mmTimer;

            window.clearTimeout(mmOpenTimer);

            if (e.type === "click") {
                e.preventDefault();
            }

            mmOpenTimer = window.setTimeout(() => MegaMenuOpen($this, mmSpeed), mmTimerFocus);
            mmActive = true;
        }).on("blur mouseleave", function () {
            window.clearTimeout(mmOpenTimer);

            if (mmActive === false) {
                mmCloseTimer = window.setTimeout(() => MegaMenuClose($(this), mmSpeed), mmTimer);
            }
        }).on("keydown", function (e) {
            switch (e.key) {
                case "ArrowRight":
                    e.preventDefault();
                    $(this).parent("li").next("li").children("a, button").trigger("focus");
                    break;
                case "ArrowLeft":
                    e.preventDefault();
                    $(this).parent("li").prev("li").children("a, button").trigger("focus");
                    break;
                case "ArrowDown":
                    e.preventDefault();
                    mmActive = true;
                    const $megaMenu = $(this).siblings(".mega-menu");
                    mmActiveItems = getAllFocusableItems($megaMenu);
                    if (mmActiveItems.length > 0) {
                        $(mmActiveItems[0]).trigger("focus");
                    }
                    break;
                case "Escape":
                    e.preventDefault();
                    MegaMenuClose($(this), mmSpeed);
                    break;
            }
        });

        // Level 2 tabs keyboard navigation
        mmLevel2Tabs.on("keydown", function (e) {
            const $megaMenu = $(this).closest(".mega-menu");
            
            handleNavigationKeys(e, $megaMenu, this, {
                customHandlers: {
                    "Enter": () => {
                        mmActive = true;
                        activateTab($(this));
                    },
                    "ArrowRight": () => {
                        mmActive = true;
                        const activePane = $megaMenu.find(".tab-pane.active.show");
                        let level3Links;
                        
                        if (activePane.length > 0) {
                            level3Links = activePane.find("a:visible");
                        } else {
                            const targetPaneId = $(this).attr("data-bs-target");
                            level3Links = $(targetPaneId).find("a:visible");
                            if (level3Links.length > 0) {
                                activateTab($(this));
                            }
                        }
                        
                        if (level3Links && level3Links.length > 0) {
                            level3Links.first().trigger("focus");
                        }
                    }
                }
            });
        });

        // Level 3 items keyboard navigation
        mmLevel3Items.on("keydown", function (e) {
            const $megaMenu = $(this).closest(".mega-menu");
            
            handleNavigationKeys(e, $megaMenu, this, {
                customHandlers: {
                    "ArrowLeft": () => {
                        mmActive = true;
                        const tabPane = $(this).closest(".tab-pane");
                        const tabId = tabPane.attr("id");
                        const correspondingTab = $(`button[data-bs-target="#${tabId}"]`);
                        correspondingTab.trigger("focus");
                    }
                }
            });
        });

        // Quick links keyboard navigation
        mmQuickLinks.on("keydown", function (e) {
            const $megaMenu = $(this).closest(".mega-menu");
            handleNavigationKeys(e, $megaMenu, this);
        });

        // Fallback handler for other items
        mmItems.on("keydown", function (e) {
            if ($(this).hasClass("nav-link") || 
                $(this).closest(".tab-pane").length > 0 || 
                $(this).closest(".mega-menu-quicklinks").length > 0) {
                return;
            }

            switch (e.key) {
                case "ArrowRight":
                case "ArrowLeft":
                    e.preventDefault();
                    mmActive = true;
                    const direction = e.key === "ArrowRight" ? "next" : "prev";
                    $(this).parents(".mega-menu").parent("li")[direction]("li").children("a, button").trigger("focus");
                    break;
                case "ArrowDown":
                case "ArrowUp":
                    e.preventDefault();
                    mmActive = true;
                    const dir = e.key === "ArrowDown" ? "next" : "prev";
                    navigateItems($(this).closest(".mega-menu"), this, dir);
                    break;
                case "Escape":
                    e.preventDefault();
                    var MenuButton = $(this).parents(".mega-menu").siblings("a, button");
                    MegaMenuClose(MenuButton, mmSpeed);
                    break;
            }
        });
    }

    function MegaMenuOpen(trigger, speed) {
        const $megaMenu = trigger.siblings(".mega-menu");
        
        trigger.attr("aria-expanded", "true");
        
        $megaMenu.stop()
            .removeClass("animate__fadeOut")
            .addClass("animate__fadeIn")
            .show();
        
        // Automatically activate the first tab
        const $firstTab = $megaMenu.find(".nav-link").first();
        if ($firstTab.length > 0) {
            const targetId = $firstTab.attr("data-bs-target");
            const $tabPane = $(targetId);
            
            // Deactivate all tabs and hide all panes
            $megaMenu.find(".nav-link").removeClass("active").attr("aria-selected", "false");
            $megaMenu.find(".tab-pane").removeClass("show active");
            
            // Activate first tab and show its pane with fade in
            $firstTab.addClass("active").attr("aria-selected", "true");
            $tabPane.addClass("active");
            $tabPane[0].offsetHeight; // Force reflow
            setTimeout(() => $tabPane.addClass("show"), 10);
        }
        
        MegaMenuClose(trigger.parents("li").siblings("li").children("a, button"), speed);
    }

    function MegaMenuClose(trigger, speed) {
        trigger.attr("aria-expanded", "false")
            .siblings(".mega-menu")
            .stop()
            .removeClass("animate__fadeIn")
            .addClass("animate__fadeOut");

        setTimeout(function () {
            const $megaMenu = trigger.siblings(".mega-menu");
            $megaMenu.hide()
                .find(".nav-link").removeClass("active").attr("aria-selected", "false").end()
                .find(".tab-pane").removeClass("show active");
        }, speed);
    }

    function MobileMenu() {
        const dropdownToggle = $("#menu");
        const dropdown = $("#dropdown-mobile-menu");
        const levels = dropdown.find(".mobile-menu-levels");
        const buttons = dropdown.find("button[data-mobilemenu]");

        dropdownToggle.on("hidden.bs.dropdown", function () {
            levels.attr("data-level", 1);
            levels.find(".mobile-menu-level-item").removeClass("active");
            levels.find(".mobile-menu-level[data-level='1'] .mobile-menu-level-item").addClass("active");
        });

        buttons.on("click", function () {
            const currentLevel = parseInt(levels.attr("data-level"));
            const currentItem = levels.find(`.mobile-menu-level[data-level="${currentLevel}"]`)
                .find(".mobile-menu-level-item.active");

            const nextItem = $(`#${$(this).attr("aria-controls")}`);
            const nextLevel = parseInt(nextItem.parents(".mobile-menu-level").attr("data-level"));

            currentItem.removeClass("active");
            nextItem.addClass("active");

            levels.attr("data-level", nextLevel);
        });
    }

    return {
        MegaMenu: MegaMenu,
        MobileMenu: MobileMenu
    };

})(jQuery);